import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from "@material-ui/core";
import { GlobalSuspenseActivator } from "@ploy-ui/core";
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";
const getErrorMessage = (error) => {
    const defaultMessage = "Skjemaoppsett for produktet mangler";
    switch (typeof error) {
        case "undefined":
            return;
        case "string":
            return error;
        case "boolean":
            return defaultMessage;
        default:
            return error.message || defaultMessage;
    }
};
export const MissingPage = ({ loading, error, header }) => inIframe() && loading ? (_jsx(GlobalSuspenseActivator, {})) : (_jsx(Grid, { container: true, children: _jsx(Grid, { item: true, xs: 12, container: true, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 12, md: 4, children: header }), _jsx(Grid, { item: true, xs: 12, children: _jsxs(Grid, { container: true, justifyContent: "center", alignItems: "center", direction: "column", children: [_jsx(Grid, { item: true, children: loading ? (_jsx(GlobalSuspenseActivator, {})) : (_jsx(WarningIcon, { fontSize: "large", color: error ? "error" : "disabled" })) }), !loading && (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, children: _jsx(Typography, { variant: "h5", children: "En feil har oppst\u00E5tt" }) }), _jsx(Grid, { item: true, children: _jsx(Typography, { variant: "subtitle1", children: getErrorMessage(error) }) })] }))] }) })] }) }) }));
function inIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
//# sourceMappingURL=MissingPage.js.map